import ReactApexChart from 'react-apexcharts'
import { salesAnalyticsChart } from '../../../../Data/Dashboard/DashboardCharts/DashboardCharts'

const SalesAnalyticsChart = () => {
  return (
    <ReactApexChart options={salesAnalyticsChart} series={salesAnalyticsChart.series} type='area' height={285} />
  )
}

export default SalesAnalyticsChart